import { ComponentNameEnum, BaseStepperPxPercentSliderFieldConfig } from '@/types';

const fontSizeFieldConfig: BaseStepperPxPercentSliderFieldConfig = {
  componentName: ComponentNameEnum.STEPPER_PX_PERCENT_SLIDER,
  options: {
    px: {
      min: 8,
      max: 100,
      step: 1,
      defaultValue: 8,
      isDefaultUnitSelected: true,
    },
  },
};

export default fontSizeFieldConfig;
